import { templateConstants } from '../constants'

export const templateLoad = () => {
  return {
    type: templateConstants.TEMPLATE_LOAD
  }
}

export const templateLoadSuccess = (payload) => {
  return {
    type: templateConstants.TEMPLATE_LOAD_SUCCESS,
    payload
  }
}

export const templateLoadFailure = (payload) => {
  return {
    type: templateConstants.TEMPLATE_LOAD_FAILURE,
    payload
  }
}

export const templateReset = () => {
  return {
    type: templateConstants.TEMPLATE_RESET
  }
}

export const templateSave = (payload) => {
  return {
    type: templateConstants.TEMPLATE_SAVE,
    payload
  }
}

export const templateSaveSuccess = (payload) => {
  return {
    type: templateConstants.TEMPLATE_SAVE_SUCCESS,
    payload
  }
}

export const templateSaveFailure = (payload) => {
  return {
    type: templateConstants.TEMPLATE_SAVE_FAILURE,
    payload
  }
}

export const templateDelete = (payload) => {
  return {
    type: templateConstants.TEMPLATE_DELETE,
    payload
  }
}

export const templateDeleteSuccess = (payload) => {
  return {
    type: templateConstants.TEMPLATE_DELETE_SUCCESS,
    payload
  }
}

export const templateDeleteFailure = (payload) => {
  return {
    type: templateConstants.TEMPLATE_DELETE_FAILURE,
    payload
  }
}
